export var TypeReferralProgramEnum;
(function (TypeReferralProgramEnum) {
    TypeReferralProgramEnum["REFER_FRIEND"] = "RF";
    TypeReferralProgramEnum["SHARE_CONTENT"] = "SC";
})(TypeReferralProgramEnum || (TypeReferralProgramEnum = {}));
export var ClientReferralInviteStatus;
(function (ClientReferralInviteStatus) {
    ClientReferralInviteStatus["INVITED"] = "INVITED";
    ClientReferralInviteStatus["ACCEPTED"] = "ACCEPTED";
    ClientReferralInviteStatus["SUBSCRIBED"] = "SUBSCRIBED";
    ClientReferralInviteStatus["FREE"] = "FREE";
})(ClientReferralInviteStatus || (ClientReferralInviteStatus = {}));
